<kendo-editor [value]="note" style="height: 160px;" [applyToWord]="true" [resizable]="resizable"
              (valueChange)="onValueChange($event)" (paste)="onPaste($event)">
    <kendo-toolbar class="k-editor-toolbar k-toolbar k-toolbar-md">
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button toggleToolbar icon="more-horizontal" [toggleable]="true"
        ></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <!--NOT SUPPORTED <tool name="InsertDate"/> -->
        <!--NOT SUPPORTED <tool name="InsertTime"/> -->
        <!--NOT SUPPORTED <tool name="InsertHorizontalRule"/> -->
        <!--?? <tool name="PasteStrip" /> -->
        <!--?? <tool name="FormatStripper"/> -->
        <!--NOT SUPPORTED <tool name="ConvertToUpper" /> -->
        <!--NOT SUPPORTED <tool name="ConvertToLower" /> -->
        <!--NOT SUPPORTED <tool name="InsertSymbol"/> -->
        <!--NOT SUPPORTED <tool name="ToggleTableBorder"/> -->
        <!--NOT SUPPORTED <tool name="ToggleScreenMode" /> -->
        <!--NOT SUPPORTED <tool name="FindAndReplace" shortcut="Ctrl+Shift+F"/> -->
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
            <kendo-toolbar-button *ngIf="expanded" kendoEditorSuperscriptButton></kendo-toolbar-button>
            <kendo-toolbar-button *ngIf="expanded" kendoEditorSubscriptButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
            <kendo-toolbar-button *ngIf="expanded" kendoEditorCleanFormattingButton></kendo-toolbar-button>
            <kendo-toolbar-button *ngIf="expanded" kendoEditorPrintButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-colorpicker *ngIf="expanded" kendoEditorForeColor></kendo-toolbar-colorpicker>
        <kendo-toolbar-colorpicker *ngIf="expanded" kendoEditorBackColor></kendo-toolbar-colorpicker>
        <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
        <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup *ngIf="expanded">
            <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup><br>
        <kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup  *ngIf="expanded">
            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
            <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup *ngIf="expanded">
            <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <kendo-toolbar-buttongroup *ngIf="expanded">
            <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
        </kendo-toolbar-buttongroup>
        <!--?? <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button> -->
        <!--?? <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button> -->
    </kendo-toolbar>
</kendo-editor>
